import React, { useState } from 'react';
import "./styles/businessDetails.css";

const BusinessDetailsStep = ({ formData, updateFormData }) => {
  const [headerPreview, setHeaderPreview] = useState(formData.headerImage || null);
  const [logoPreview, setLogoPreview] = useState(formData.logoImage || null);
  const [imageError, setImageError] = useState(""); // Added for displaying image size error

  const handleImageUpload = (field, file) => {
    if (file) {
      // Validate file size (5MB limit)
      if (file.size > 5 * 1024 * 1024) {
        setImageError("File is too large. Maximum size is 5MB.");
        // Clear the input field if the file is too large
        if (field === 'headerImage') {
          document.getElementById('headerImage').value = null;
          setHeaderPreview(null); 
          updateFormData(field, null);
        } else if (field === 'logoImage') {
          document.getElementById('logoImage').value = null;
          setLogoPreview(null);
          updateFormData(field, null);
        }
        return; 
      }
      setImageError(""); // Clear any previous error

      const reader = new FileReader();
      reader.onloadend = () => {
        updateFormData(field, reader.result);
        if (field === 'headerImage') {
          setHeaderPreview(reader.result);
        } else if (field === 'logoImage') {
          setLogoPreview(reader.result);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="step-content business-details">
      <h2>Business Details</h2>
      <input
        type="text"
        value={formData.businessName}
        onChange={(e) => updateFormData('businessName', e.target.value)}
        placeholder="Business name"
      />
      {imageError && <p className="error-message">{imageError}</p>} {/* Display image error */}
      <div className="file-upload" onClick={() => document.getElementById('headerImage').click()}>
        <input
          id="headerImage"
          type="file"
          hidden
          onChange={(e) => handleImageUpload('headerImage', e.target.files[0])}
        />
        <p>Click to upload header image</p>
        {headerPreview && <img src={headerPreview} alt="Header preview" />}
      </div>
      <div className="file-upload" onClick={() => document.getElementById('logoImage').click()}>
        <input
          id="logoImage"
          type="file"
          hidden
          onChange={(e) => handleImageUpload('logoImage', e.target.files[0])}
        />
        <p>Click to upload logo</p>
        {logoPreview && <img src={logoPreview} alt="Logo preview" />}
      </div>
    </div>
  );
};

export default BusinessDetailsStep;
